var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{style:(_vm.theme),attrs:{"small":""},on:{"click":function($event){return _vm.generateCode()}}},[_vm._v("Generate Code")])
}
var staticRenderFns = []

export { render, staticRenderFns }